import { motion } from "framer-motion";
import { springs } from "../../ui/motion";

interface Props {
  body: string;
  delay?: number;
}

export function BodyCard({ body, delay = 0.1 }: Props) {
  return (
    <motion.div
      className="relative pl-3.5 mb-5"
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ ...springs.smooth, delay }}
    >
      {/* Left accent line — category color */}
      <motion.div
        className="absolute left-0 top-0.5 bottom-0.5 w-[2px] rounded-full"
        initial={{ scaleY: 0 }}
        animate={{ scaleY: 1 }}
        transition={{ ...springs.smooth, delay: delay + 0.08 }}
        style={{
          backgroundColor: "var(--detail-accent, var(--color-accent))",
          transformOrigin: "top",
        }}
      />
      <p className="text-[13px] text-secondary leading-[1.7] whitespace-pre-wrap">
        {body}
      </p>
    </motion.div>
  );
}
